/** REVIEW WHAT'S STAY */

import { httpV1 as http } from '../api';

const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function consult(params) {
  return http.get('/cartos/fgts/balance', { params });
}

export async function simulate(data) {
  return http.post('/cartos/fgts/simulation', data);
}

export async function verify(params) {
  return http.get('/cartos/fgts/proposal', { params });
}

export async function approve(data) {
  return http.post(`${ALT_API_URL}/cartos/fgts/credit-operation`, data);
}

export async function tryAgain(data) {
  return http.put(`${ALT_API_URL}/cartos/fgts/credit-operation`, data);
}

export async function proposalAcquittance(data) {
  return http.put(`${ALT_API_URL}/cartos/fgts/renegotiation/proposal`, data);
}

export async function withdrawalProposal(data) {
  return http.post('/cartos/fgts/proposal/reversal', { ...data });
}

export async function cancel(proposalId) {
  return http.delete(`/cartos/fgts/proposal/${proposalId}`);
}

export async function generateReceipt(proposalId) {
  return http.get(`/cartos/fgts/proposal/${proposalId}/generate_receipt`);
}
